import React, { useState } from 'react'
import PreviewPopupTable from './PreviewPopupTable';
import CommonLayout from '../CommonLayout';


const EditProjectIdAction = ({prevData,newData}) => { 
  const [showPopup,setShowPopup] = useState(false);
  const [projct, setProjctData] = useState({})
  const fieldsData = [
      {colKey:"product_code", colText:"Project ID"},
      {colKey:"description", colText:"Description"},

  ]

  const showPopupHanldel = (data) =>{
    setProjctData(data)
    setShowPopup(true)
  }
    
  return <> 
    <CommonLayout 
        prevData={prevData}
        newData={newData}
        fieldsData={fieldsData}
        showPopupHanldel={showPopupHanldel}
    />  
    {showPopup && <PreviewPopupTable projct={projct} hidePopup={()=>setShowPopup(false)}/>}
  </>
}

export default EditProjectIdAction